import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../../../Base/Components/BaseModal/BaseModal';
import ManagerEditMemberProfile from './ManagerEditMemberProfile';
import { User } from '../../../../../../graphql/graphql';

interface Props extends BaseModalProps {
	workplaceMemberId: string;
	user: User;
	onSuccess: () => void;
}

const ManagerEditMemberProfileModal: React.FC<Props> = props => {
	return (
		<BaseModal {...props} title='component.managerEditWorkerProfile.modalTitle'>
			<ManagerEditMemberProfile
				workplaceMemberId={props.workplaceMemberId}
				user={props.user}
				onSuccess={props.onSuccess}
			/>
		</BaseModal>
	);
};

export default ManagerEditMemberProfileModal;
